var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerBar"},[_c('div',{staticClass:"bar"},[_c('p',[_vm._v("© 2021 Liquidzed")])])])}]

export { render, staticRenderFns }